import React from 'react';
import { MenuItem } from '@mui/material';
import { CompoundMetaData } from '../../types/reports';
import DropdownSelectWrapper from '../../components/common/forms/DropdownSelectWrapper';

type CompoundFilterSelectProps = {
  compoundMetaData: Record<string, CompoundMetaData>;
  setSelectedChartCompound: (compound: string) => void;
  selectedCompound?: string;
};

const CompoundFilterSelect = ({
  compoundMetaData,
  setSelectedChartCompound,
  selectedCompound,
}: CompoundFilterSelectProps) => {
  return (
    <DropdownSelectWrapper
      initialSelectedValue={selectedCompound}
      onChangeFn={setSelectedChartCompound}
      renderValueFn={(selected: string, open: boolean) => {
        if (!selected) return 'Compound';
        return open ? compoundMetaData[selected].fullname : selected;
      }}
    >
      <MenuItem value="">Compound</MenuItem>
      {Object.entries(compoundMetaData).map(([key, { fullname }]) => (
        <MenuItem key={key} value={key}>
          {fullname} ({key})
        </MenuItem>
      ))}
    </DropdownSelectWrapper>
  );
};

export default CompoundFilterSelect;
